import { Component, computed, input, InputSignal } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import {
  MatCard,
  MatCardContent,
  MatCardTitle,
} from '@angular/material/card';
import { VulcanIconComponent } from '@eagle-i/vulcan-component-library';
import html2canvas from 'html2canvas';
import { GenRestorationMetricType } from '../../../../../../../generated/serverModels/GenRestorationMetricType';
import { BaseStateReportWidget } from '../base-state-report-widget';

@Component({
  selector: 'tgrid-resiliency-chart-widget',
  imports: [
    MatCard,
    MatCardContent,
    MatCardTitle,
    MatIconButton,
    VulcanIconComponent,
  ],
  templateUrl: './resiliency-chart-widget.component.html',
  styleUrl: './resiliency-chart-widget.component.scss',
  standalone: true,
})
export class ResiliencyChartWidgetComponent extends BaseStateReportWidget {

  public type: InputSignal<GenRestorationMetricType> = input.required();

  protected title = computed(() => {
    switch (this.type()) {
      case GenRestorationMetricType.NORMALIZED_IMPACT:
        return 'Top 10 Counties by Normalized Impact Level';
      case GenRestorationMetricType.RECOVERY_DURATION:
        return 'Top 10 Counties by Recovery Duration';
      default:
        return 'N/A';
    }
  });

  protected imageUrl = computed(() => {
    if (!this.stateParam() || !this.type()) return undefined;
    return `/api/curve/system-resiliency/${this.stateParam()}?type=${this.type().toString()}`;
  });

  protected override async export(): Promise<void> {
    try {
      const canvas = await html2canvas(this.exportContent()?.nativeElement);
      const url = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = url;
      a.download = `${this.stateParam()}_${this.type().toString().toLowerCase()}.png`;
      a.click();
      this.snackBar.open('Export downloaded successfully', 'Close', { duration: 3000 });
    } catch (err) {
      console.error(err);
      this.snackBar.open('Export failed. Please try again.', 'Close', { duration: 3000 });
    }
  }

}
